'use client'; // This component will run in the browser

import Link from 'next/link';
import dynamic from 'next/dynamic';

// The dynamic import with ssr: false is now safely inside a Client Component
const FlashSalesCountdown = dynamic(() => import('./FlashSalesCountdown'), {
  ssr: false,
  // Add a simple loading skeleton for the countdown to prevent layout shift
  loading: () => (
    <div
      style={{
        width: '220px',
        height: '40px',
        backgroundColor: '#e0e0e0',
        borderRadius: '4px',
      }}
    />
  ),
});

interface FlashSalesHeaderProps {
  // It needs the date to pass down to the countdown
  endDate: string | number | Date | undefined;
  href?: string;
  title?: string;
}

export const FlashSalesHeader: React.FC<FlashSalesHeaderProps> = ({
  endDate,
  href = '/hot-deals',
  title = 'Hot Deals',
}) => {
  return (
    <div className="section-header">
      {endDate ? (
        <FlashSalesCountdown date={endDate} title={title} />
      ) : (
        // Optionally, render a placeholder or just the title if no date is available
        <h2 className="mb-0">{title}</h2>
      )}
      <div className="section-header__action order-sm-2 d-none d-sm-block">
        <Link className="trk-btn trk-btn--primary" href={href}>
          View All
        </Link>
      </div>
    </div>
  );
};
